let paymentGatewayService = (paysafeGatewayService, stripeGatewayService) => {

  let isLoaded;

  /*
            * Automatically gets called by mount() but can optionally
            * be called globally on every page (recommended for Stripe for fraud
            * tracking). load() will only ever load a script once.
            */
  const load = options => {
    if (isLoaded) {
      return Promise.resolve();
    }

    let promise;

    if (options.none) {
      promise = Promise.resolve();
    }

    if (options.paysafe) {
      promise = paysafeGatewayService.load();
    }

    if (options.stripe) {
      promise = stripeGatewayService.load();
    }

    if (promise) {
      return promise.then(() => isLoaded = true);
    }

    return Promise.reject();
  };

  const mount = options => {
    return load(options)
      .then(() => {
        if (options.paysafe) {
          return paysafeGatewayService.mount(options.paysafe);
        }

        if (options.stripe) {
          return stripeGatewayService.mount(options.stripe);
        }
      });
  };

  return {
    load,
    mount
  };
};

paymentGatewayService.$inject = [ 'paysafeGatewayService', 'stripeGatewayService' ];

export default paymentGatewayService;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/shared/journey-ui/payment/services/payment.gateway.service.js